<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button
        class="custom-btn"
        @click="() => this.$router.push({ name: 'ContactsAdd' })"
        type="primary"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="contacts" border height="calc(100vh - 210px)">
      <el-table-column prop="region" label="Viloyat" min-width="150" />
      <el-table-column prop="district" label="Tuman/Shahar" min-width="150" />
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="150" />
      <el-table-column prop="phone" label="Boglanish" min-width="150" />
      <!-- <el-table-column prop="position" label="Pozitsiya" min-width="150" /> -->
      <el-table-column width="100">
        <template #default="scope">
          <!-- <el-button
            size="small"
            @click="onEditContact(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          > -->
          <el-button
            size="small"
            @click="onDeleteContact(scope.row.id)"
            type="danger"
            >O'chirish</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "ContactsList",
  data() {
    return {
      loading: false,
      contacts: [],
    };
  },
  methods: {
    onEditContact(id) {
      this.$router.push({ name: "ContactsEdit", params: { id } });
    },
    onDeleteContact(id) {
      ElMessageBox.confirm("Ushu kontaktni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .request({
              url: `/api/v1/contact`,
              method: "delete",
              data: { id },
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: "Ushbu kontakt o'chirildi",
              });
              this.getContactsList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getContactsList() {
      this.loading = true;
      this.$http
        .get("/api/v1/contact")
        .then(({ data }) => {
          this.contacts = data.contacts;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loading = true;
    this.getContactsList();
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}
</style>
